import React, { useState } from 'react';
import { HiOutlineMail, HiOutlineLockClosed, HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi'; // Tambahkan ikon mata
import { loginUser } from '../services/authService';
import './Login.css';
import bgImage from '../teagarden.png'; 

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State untuk kontrol mata
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = loginUser(email, password);
    if (result.success) {
      window.location.href = "/beranda"; 
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="login-wrapper" style={{ backgroundImage: `url(${bgImage})` }}>
      <nav className="header-nav">
        <img src="/assets/logo-agrid.png" alt="Agrid Logo" className="brand-logo" />
        <div className="partner-section">
          <img src="/assets/danantara.png" alt="Danantara" />
          <img src="/assets/telu.png" alt="TelU" />
          <img src="/assets/telkom.png" alt="Telkom" /> 
          <img src="/assets/innovillage.png" alt="Innovillage" />
          <img src="/assets/sisgrid.png" alt="Sisgrid" />
        </div>
      </nav>

      <main className="login-container">
        <div className="glass-card">
          <h1>Sign in</h1>
          <p className="description">Selamat datang di website sistem monitoring akuaponik dan fish feeder</p>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-box">{error}</div>}
            
            <div className="input-field">
              <HiOutlineMail className="field-icon" />
              <input 
                type="email" 
                placeholder="Email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required 
              />
            </div>
            
            <div className="input-field">
              <HiOutlineLockClosed className="field-icon" />
              <input 
                type={showPassword ? "text" : "password"} // Logika ganti tipe input
                placeholder="Password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required 
              />
              {/* Tombol Ikon Mata */}
              <div 
                className="eye-icon-container" 
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <HiOutlineEyeOff /> : <HiOutlineEye />}
              </div>
            </div>
            
            <button type="submit" className="btn-primary">Login</button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Login;